import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, Observable, tap, throwError } from "rxjs";
import { Notificacao } from "../models/notificacao.model";

@Injectable({
    providedIn: 'root',
})
export class NotificacaoService {
    private apiUrl = `${environment.advContabilApi}/api/notificacao`;
    private listarNotificacao = `${this.apiUrl}/ListarTodas`
    private deleteNotificacao = `${this.apiUrl}/ExcluirNotificacao/`
    private marcarComoLidaNotificacao = `${this.apiUrl}/MarcarNotificacaoComoLida`

    constructor(private http: HttpClient) { }

    listaNotificao(usuarioId: string): Observable<Notificacao[]> {
        const params = new HttpParams().set('usuarioId', usuarioId);
        return this.http.get<Notificacao[]>(`${this.listarNotificacao}`, { params });
    }

    deleteLancamentoCaixa(id: any): Observable<any> {
        return this.http.delete<any>(`${this.deleteNotificacao}${id}`).pipe(
            tap((resposta) => {
            }),
            catchError((error) => {
                console.error('Erro ao deletar notificação', error);
                return throwError(() => new Error('Falha ao deletar notificação'));
            })
        );
    }

    MarcarNotificacaoComoLida(id: number): Observable<any> {
        return this.http.put<any>(`${this.marcarComoLidaNotificacao}`, id);
    }
}